import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from 'ui-component/Pagination';
import Scroller from 'ui-component/Scroller';

import { FaSearch, FaTimes, FaUser } from 'react-icons/fa';
import Filter from 'ui-component/filter-menu/Filter';
import moment from 'moment';
import { Skeleton, Avatar } from '@mui/material';
import CurrencyValue from 'ui-component/CurrencyValue';
import usePermissions from 'hooks/usePermissions';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import { useQuery } from 'react-query';
import { ImSpinner2 } from 'react-icons/im';
import SortableHeader from 'ui-component/SortableHeader';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';

import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import StatusBadge from 'ui-component/StatusBadge';
import useIsMobile from 'utils/isMobileUtils';
import { TbDatabaseExclamation } from 'react-icons/tb';


const CreditNotesTabComponent = (id) => {
	const history = useNavigate();
	const isMobile = useIsMobile();
	const [sortByFilter, setSortByFilter] = useState();
	const [isListLoading, setIsListLoading] = useState(true);
	const [activeFilters, setActiveFilters] = useState({});
	const [searchField, setSearchField] = useState();
	const [searchValue, setSearchValue] = useState();
	const [paginationUrl, setPaginationUrl] = useState();
	const [allPermissions, hasEveryPermission] = usePermissions();
	const [filters, setFilters] = useState([]);
	const [searchTimeout, setSearchTimeout] = useState(null);

	const updateSortByStatus = (name) => {
		if (sortByFilter?.field === name) {
			setSortByFilter((e) => ({
				...e,
				direction: e?.direction == 'asc' ? 'desc' : 'asc'
			}));
		} else {
			setSortByFilter((e) => ({
				field: name,
				direction: 'asc'
			}));
		}
	};

	const {
		data: reqData,
		isFetching
	} = useQuery(
		['contact-quotations', id, activeFilters, searchField, paginationUrl, sortByFilter],
		() => {
			const contactId = id?.id;

			return paginationUrl
				? api.plainAPIRequest(paginationUrl)
				: api.getContactCreditNotesLists(
					contactId,
					activeFilters,
					searchField?.length > 2 ? searchField : null,
					sortByFilter
				);
		},
		{
			initialData: (e) => {
				setIsListLoading(true);
			},
			onSuccess: (e) => {
				setIsListLoading(false);
			},
		}
	);

	const getFiltersList = () => {
		api.getContactCreditNotesFilter(id).then((res) => {
			setFilters(res.data);
		});
	};

	const handleSearch = (e) => {
		let text = e.target.value;

		setSearchValue(text);
		setIsListLoading(true);
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		let timeout = setTimeout(() => {
			setSearchField(text)
		}, 500);

		setSearchTimeout(timeout);
	};

	useEffect(() => {
		getFiltersList();
	}, [])

	const handleData = (data) => {
		setPaginationUrl(data);
	};

	const getItemList = reqData?.data?.data?.data;
	const paginationData = reqData?.data?.data;

	const statusColorMap = {
		Draft: '#acacac',
		Open: '#EBA562',
		Paid: '#00C13B',
		Canceled: '#E37560'
	};

	const handleFilterRemove = (name) => {
		const copy = { ...activeFilters };
		delete copy[name];
		setActiveFilters(copy);
	};

	return (
		<>
			{
				!isMobile ? (
					<>
						<div className=" align-items-center justify-content-between TableSerachBar">
							<div className="flex gap-2">
								<Filter
									activeFilters={activeFilters}
									onSubmit={setActiveFilters}
									filters={filters}
									multi={undefined}
									source={'contact-sales-order'}
									showActiveFilters={false}
								/>
							</div>
							<form className="form-inline navbar-search" style={{ display: 'flex', gap: '5px' }} onSubmit={(e) => e.preventDefault()}>
								{isFetching && (
									<p className="m-0" style={{ display: 'flex', gap: '3px', alignItems: 'center', fontSize: '10px' }}>
										<ImSpinner2 className="fa-spin" />
									</p>
								)}

								<div className="input-group">
									<input
										type="text"
										className="form-control bg-white border"
										placeholder="Search"
										aria-label="Search"
										aria-describedby="basic-addon2"
										value={searchValue || ''}
										onChange={handleSearch}
										style={{ width: '100%' }}
									/>
									<span className="searchIcon">
            <FaSearch />
          </span>
								</div>
							</form>
						</div>
						{
							Object.keys(activeFilters || {}).length > 0 && (
								<>
									<div className="flex align-items-center gap-4" style={{ padding: '0 10px' }}>
										<div className="text-gray-800 fw-500">
											Filter Result:
										</div>
										<div>
											<div className="filter-container" >
												<div className="filter-buttons">
													{Object.keys(activeFilters || {}).map((key) => {
														const values = activeFilters[key];

														if (key != 'startDate' && key != 'endDate') {
															return (
																<div className="selected-filter-pill" key={key}>
																	<span>{Array.isArray(values) ? values.map((value) => value.label).join(', ') : values?.label}</span>
																	<span className="d-flex">
                    <FaTimes style={{ cursor: 'pointer' }} onClick={() => handleFilterRemove(key)} />
                  </span>
																</div>
															);
														}
													})}
												</div>
											</div>
										</div>
									</div>
								</>
							)
						}
						<div className="estimation-table-area">
							<div className="table-side">
								<div className="table-responsive-xl tableData estimationList">
									<Scroller extraHeight={30}>
										<table className="table  min-width-unset tbl-space pm-table d-none d-md-table">
											<thead>
											<tr className="sticky-header">
												<th scope="col" width="">
													<SortableHeader
														name="invoice_number"
														currentSortBy={sortByFilter}
														onClick={() => {
															updateSortByStatus('invoice_number');
														}}
													>
														Reference
													</SortableHeader>
												</th>
												<th scope="col">
													<SortableHeader
														name="manager"
														currentSortBy={sortByFilter}
														onClick={() => {
															updateSortByStatus('manager');
														}}
													>
														Manager
													</SortableHeader>
												</th>
												<th scope="col">
													<SortableHeader
														name="date"
														currentSortBy={sortByFilter}
														onClick={() => {
															updateSortByStatus('date');
														}}
													>
														Date
													</SortableHeader>
												</th>
												<th scope="col">
													<SortableHeader
														name="qty"
														currentSortBy={sortByFilter}
														onClick={() => {
															updateSortByStatus('qty');
														}}
													>
														Qty
													</SortableHeader>
												</th>
												<th scope="col">
													<SortableHeader
														name="total"
														currentSortBy={sortByFilter}
														onClick={() => {
															updateSortByStatus('total');
														}}
													>
														Total
													</SortableHeader>
												</th>
												<th scope="col" style={{ width: '110px' }}>
													<SortableHeader
														name="status"
														currentSortBy={sortByFilter}
														onClick={() => {
															updateSortByStatus('status');
														}}
														style={{ maxWidth: '100px' }}
													>
														Status
													</SortableHeader>
												</th>
											</tr>
											</thead>
											<tbody>
											{
												isListLoading ? (
													<>
														{[...Array(10)].map((e, i) => (
															<tr style={{ height: '35px' }} key={i}>
																{[...Array(6)].map((e, i) => (
																	<td key={i}>
																		<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
																	</td>
																))}
															</tr>
														))}
													</>
												) : (
													<>
														{
															getItemList?.length > 0 ? (
																<>
																	{getItemList?.map((item, index) => {
																		return (
																			<tr key={index}>
																				<td
																					className={
																						hasEveryPermission(['View Sales Orders Details'])
																							? 'cursor-pointer align-middle font14'
																							: 'align-middle font14'
																					}
																					onClick={(e) => {
																						if (hasEveryPermission(['View Sales Orders Details'])) {
																							history(`/sales/invoices/${item?.id}?ref=${item?.ref}`);
																						}
																					}}
																				>
																					{item?.master_status?.name == 'Draft' ? (
																						<>
																							<span style={{ fontStyle: 'italic', color: '#929598' }}>{item?.invoice_number}</span>
																						</>
																					) : (
																						<>{item?.invoice_number}</>
																					)}
																				</td>
																				<td
																					className={
																						hasEveryPermission(['View Sales Orders Details'])
																							? 'cursor-pointer align-middle font14'
																							: 'align-middle font14'
																					}
																					onClick={(e) => {
																						if (hasEveryPermission(['View Sales Orders Details'])) {
																							history(`/sales/invoices/${item?.id}?ref=${item?.ref}`);
																						}
																					}}
																				>
																					{item?.sales_person?.first_name} {item?.sales_person?.last_name}
																				</td>
																				<td
																					className={
																						hasEveryPermission(['View Sales Orders Details'])
																							? 'cursor-pointer align-middle font14'
																							: 'align-middle font14'
																					}
																					onClick={(e) => {
																						if (hasEveryPermission(['View Sales Orders Details'])) {
																							history(`/sales/invoices/${item?.id}?ref=${item?.ref}`);
																						}
																					}}
																				>
																					{moment(item?.start_date).format(CommonDateOnlyFormat)}
																				</td>
																				<td
																					className={
																						hasEveryPermission(['View Sales Orders Details'])
																							? 'cursor-pointer align-middle font14'
																							: 'align-middle font14'
																					}
																					onClick={(e) => {
																						if (hasEveryPermission(['View Sales Orders Details'])) {
																							history(`/sales/invoices/${item?.id}?ref=${item?.ref}`);
																						}
																					}}
																				>
																					{item?.item_qty?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}
																				</td>
																				<td
																					className={
																						hasEveryPermission(['View Sales Orders Details'])
																							? 'cursor-pointer align-middle font14'
																							: 'align-middle font14'
																					}
																					onClick={(e) => {
																						if (hasEveryPermission(['View Sales Orders Details'])) {
																							history(`/sales/invoices/${item?.id}?ref=${item?.ref}`);
																						}
																					}}
																				>
																					<CurrencyValue currencyObject={item?.converted_currency_total} defaultCurrency={item?.currency} />
																				</td>
																				<td
																					style={{ width: '110px' }}
																					className={
																						hasEveryPermission(['View Sales Orders Details'])
																							? 'cursor-pointer align-middle font14'
																							: 'align-middle font14'
																					}
																					onClick={(e) => {
																						if (hasEveryPermission(['View Sales Orders Details'])) {
																							history(`/sales/invoices/${item?.id}?ref=${item?.ref}`);
																						}
																					}}
																				>
																					<StatusBadge itemStatus={item?.master_status?.name} />
																				</td>
																			</tr>
																		);
																	})}
																</>
															) : (
																<>
																	{
																		getItemList?.length < 1 && (
																			<tr className="no-hover">
																				<td colSpan={6} style={{ borderBottom: '0 !important' }}>
																					<div className="not-found-container" style={{ height: 'calc(100vh - 296px)' }}>
																						<div className="not-found-icon">
																							<img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
																						</div>
																						<h6 className="not-found-text">No Data Available</h6>
																						<Link to={'/sales/invoices/create'} className="btn btn-primary btn-outlined-main">
																							Create new Invoice?
																						</Link>
																					</div>
																				</td>
																			</tr>
																		)
																	}
																</>
															)
														}
													</>
												)
											}
											</tbody>
										</table>
									</Scroller>
								</div>
								{isListLoading ? (
									<>
										<div
											className="d-flex align-items-center justify-content-center paginationcon"
											style={{
												padding: '5px 0',
												marginBottom: '-8px'
											}}
										>
											<div className="col-sm-12 col-md-6"></div>
											<div className="col-sm-12 col-md-6">
												<div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
													<div style={{ marginRight: '5px' }}>
														<div style={{ width: '150px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }}></Skeleton>
														</div>
													</div>
													<div>
														<div style={{ width: '70px' }}>
															<Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }}></Skeleton>
														</div>
													</div>
												</div>
											</div>
										</div>
									</>
								) : (
									<>
										<Pagination pagination={paginationData} data={handleData} onLoading={(e) => { }} reactQuery />
									</>
								)}
							</div>
						</div>
					</>
				) : (
					<>
						<div
							style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, paddingTop: 0, paddingBottom: 5, paddingLeft: 20, paddingRight: 20 }}
							className="show-on-mobile"
						>
							<form className="form-inline navbar-search" style={{ flex: 1 }}>
								<div style={{ position: 'relative', width: '100%' }}>
									<input
										type="text"
										className="form-control bg-white border"
										placeholder="Search"
										aria-label="Search"
										aria-describedby="basic-addon2"
										value={searchValue || ''}
										onChange={handleSearch}
										style={{ width: '100%', paddingRight: 36 }}
									/>
									<span
										className="searchIcon"
										style={{
											position: 'absolute',
											right: 10,
											top: '50%',
											transform: 'translateY(-50%)',
											color: '#888',
											pointerEvents: 'none'
										}}
									>
            <FaSearch />
          </span>
								</div>
							</form>
							<div style={{ flexShrink: 0 }}>
								<Filter
									activeFilters={activeFilters}
									onSubmit={setActiveFilters}
									filters={filters}
									multi={undefined}
									source={'contact-sales-order'}
								/>
							</div>
						</div>
						<Scroller extraHeight={30}>
							<div className="inv-cards-list">
								{
									isListLoading ? (
										<>
											{[...Array(5)].map((e, i) => (
												<div
													key={i}
													className="order-list-card active-action"
													style={{
														background: i % 2 === 0 ? '#f9f9f9' : '#fff'
													}}
												>
													<div className="order-list-card-header">
														<h6 className="order-no">
															<div style={{ width: '150px' }}>
																<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
															</div>
														</h6>
														<div style={{ width: '75px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
														</div>
													</div>
													<div className="order-list-card-body">
														<div className="order-contacts">
															<p className="order-customer">
																<div style={{ width: '200px' }}>
																	<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
																</div>
															</p>
														</div>
														<p className="total-val" style={{ color: '#acacac' }}>
															<div style={{ width: '100px' }}>
																<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
															</div>
														</p>
													</div>
													<div className="order-list-card-footer">
														<div className="order-icon-items">
															<div style={{ width: '100px' }}>
																<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
															</div>
														</div>
														<div className="order-icon-items show-on-mobile">
															<div className="order-icon-item order-manager">
																<div style={{ color: '#acacac' }}>
																	<div style={{ width: '100px' }}>
																		<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											))}
										</>
									) : (
										<>
											{getItemList?.map((item, index) => (
												<div
													key={index}
													className="order-list-card active-action"
													style={{
														background: index % 2 === 0 ? '#f9f9f9' : '#fff'
													}}
													onClick={() => {
														history(`/sales/invoices/${item?.id}?ref=${item?.ref}`);
													}}
												>
													<div className="order-list-card-header">
														<h6 className="order-no">{item?.invoice_number}</h6>
														<p className="order-date">{moment(item?.start_date).format(CommonDateOnlyFormat)}</p>
													</div>
													<div className="order-list-card-body">
														<div className="order-contacts">
															<p className="order-customer">
																<PrivacyModeContent>{item?.customer?.name}</PrivacyModeContent>
															</p>
															{item?.transit_company && (
																<p className="order-transit">
																	via{' '}
																	<PrivacyModeContent notUserRestricted>
																		{item?.transit_company?.name
																			? item?.transit_company?.name && item.transit_company?.name.length > 20
																				? item.transit_company?.name.substring(0, 20) + '...'
																				: item?.transit_company?.name
																			: '-'}
																	</PrivacyModeContent>
																</p>
															)}
														</div>
														<p className="total-val" style={{ color: statusColorMap[item?.master_status?.name] || '#acacac' }}>
															<CurrencyValue currencyObject={item?.converted_total_price} defaultCurrency={item?.currency} />
														</p>
													</div>
													<div className="order-list-card-footer">
														<div className="order-icon-items">
															{item?.master_status?.name != 'Credit Note' && !item?.is_credit_note && (
																<div
																	className="order-icon-item order-manager"
																	style={{ color: statusColorMap[item?.master_status?.name] || '#acacac' }}
																>
																	<div className="icons-span hide-on-mobile">
																		<Avatar sx={{ width: 20, height: 20 }} style={{ fontSize: 10 }} src={item?.sales_person?.user_profile}>
																			{item?.sales_person?.first_name?.split(' ')?.[0]?.slice(0, 1)}
																			{item?.sales_person?.last_name?.split(' ')?.[1]?.slice(0, 1)}
																		</Avatar>
																	</div>
																	<div className="show-on-mobile">
																		<FaUser />
																	</div>
																	<div>
																		{item?.sales_person?.first_name
																			? `${item?.sales_person?.first_name} ${item?.sales_person?.last_name}`
																			: '-'}
																	</div>
																</div>
															)}
															{item?.master_status?.name != 'Draft' &&
																item?.master_status?.name != 'Estimated' &&
																item?.master_status?.name != 'Pending Manager' &&
																item?.master_status?.name != 'Pending' &&
																item?.master_status?.name != 'Credit Note' &&
																item?.master_status?.name != 'Cancelled' && (
																	<div
																		className={`order-icon-item  ${item?.paid_status == 'Paid'
																			? 'order-paid'
																			: item?.paid_status == 'Partial'
																				? 'order-partial-paid'
																				: 'order-unpaid'
																		}`}
																	>
																		<span>{item?.paid_status}</span>
																	</div>
																)}
														</div>
														<div
															className={`order-status order-status-${item?.master_status?.name
																?.toLowerCase()
																?.replaceAll(' ', '-')} hide-on-mobile`}
														>
															{item?.master_status?.name}
														</div>
														<div className="order-icon-items show-on-mobile">
															<div className="order-icon-item order-manager">
																<div
																	className="order-circle"
																	style={{
																		background: statusColorMap[item?.master_status?.name] || '#acacac',
																		width: 10,
																		height: 10,
																		borderRadius: '50%',
																		display: 'inline-block'
																	}}
																></div>
																<div style={{ color: statusColorMap[item?.master_status?.name] || '#acacac' }}>
																	{item?.master_status?.name}
																</div>
															</div>
														</div>
													</div>
												</div>
											))}
											{getItemList?.length < 1 && (
												<div className="w-100">
													<div className="not-found-container">
														<div className="not-found-icon">
															<TbDatabaseExclamation />
														</div>
														<h6 className="not-found-text">No Data Available</h6>
														<Link to={'/sales/invoices/create'} className="btn btn-primary btn-outlined-main">
															Create new Invoice?
														</Link>
													</div>
												</div>
											)}
										</>
									)
								}
							</div>
						</Scroller>
						{isListLoading ? (
							<>
								<div
									className="d-flex align-items-center justify-content-center paginationcon"
									style={{
										padding: '5px 0',
										marginBottom: '-8px'
									}}
								>
									<div className="col-sm-12 col-md-6"></div>
									<div className="col-sm-12 col-md-6">
										<div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
											<div style={{ marginRight: '5px' }}>
												<div style={{ width: '150px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }}></Skeleton>
												</div>
											</div>
											<div>
												<div style={{ width: '70px' }}>
													<Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }}></Skeleton>
												</div>
											</div>
										</div>
									</div>
								</div>
							</>
						) : (
							<>
								<Pagination pagination={paginationData} data={handleData} onLoading={(e) => { }} reactQuery />
							</>
						)}
					</>
				)
			}
		</>
	);
};

export default CreditNotesTabComponent;